import { ThunkDispatch } from '@reduxjs/toolkit';
import { addHistoryNoti, addNotification } from '@slice/orderManager.slice';
import { pushNotifyTicket } from '@slice/select.slice';
import { RootState } from 'app/store';
import React, { useCallback, useEffect } from 'react';
import toast from 'react-hot-toast/headless';
import { batch, useDispatch, useSelector } from 'react-redux';
import { FcmMsg } from './useFcmMessages';
import { DivToast } from './WapperNotification';

export function useTicketNotification() {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  const ticketNotify = useSelector((s: RootState) => s.select.notifyTicket);

  const isACNotify = useSelector((s: RootState) => s.orderManager.isACNotify);

  // Nhận tin thô từ useFcmMessages (cả foreground lẫn chạy nền) -> đẩy vào redux + hiện popup
  const onTicketMessage = useCallback(
    (msg: FcmMsg) => {
      dispatch(pushNotifyTicket(msg));
      if (msg.idPhieu) {
        batch(() => {
          dispatch(addNotification(msg)); // thêm vào thông báo save
          dispatch(addHistoryNoti(msg)); // thêm vào lịch sử thông báo save
        });
        // Popup góc phải cho MỌI người nhận thông báo, ở MỌI trang (chung khung + thời gian hiện với popup đơn).
        // id theo mã phiếu: cùng 1 phiếu báo lại thì thay popup cũ, không chồng nhiều popup.
        // Không truyền hàm của đơn: DivToast tự mở phiếu khi có idPhieu.
        const noop = () => undefined;
        toast(
          React.createElement(DivToast, {
            notification: msg,
            handleDetail: noop,
            handleMenu: noop,
            handleQActions: noop
          }),
          {
            id: `ticket-${msg.idPhieu}`,
            duration: isACNotify ? 10000 : 60000 * 60
          }
        );
      }
    },
    [isACNotify]
  );

  useEffect(() => {
    if (!ticketNotify) return;

    // mã phiếu thì ko xoá vì để phần UI phiếu lo việc này
    // gọi lấy phiếu / cập nhật data cho phiếu nữa
  }, [ticketNotify?.idPhieu]);

  return { onTicketMessage };
}
